export default "__VITE_ASSET__2UBGFoZY__"